export const PERSON_TYPE = 'Person';

export const DEFAULT_PERSON_LAST_NAME = '[last name]';

export const PERSON_FORM_NAMES = {
    firstName: 'name.firstName',
    lastName: 'name.lastName',
    email: 'contactInfo.email.address'
};

export const PERSON_GROUP_BY = {
    none: 'none',
    name: 'name'
};

export const PERSON_DEFAULT_VALUES = {
    typeString: 'Business'
};
